import { NO_CACHE } from '@thyme/libs/src/api/types/api'

export const thymeboxDefaultHeaders = { 'Cache-Control': NO_CACHE }
